(() => {
  'use strict';
  // Set the intended landing market once; respect later explicit country choices.
  const form = document.getElementById('StadiartSpanishDestination');
  try {
    if (!sessionStorage.getItem('stadiart-es-destination-v1')) {
      sessionStorage.setItem('stadiart-es-destination-v1', 'ES');
      const landing = new URL(window.location.href);
      if (form && !landing.searchParams.has('country')) {
        form.querySelectorAll('[name="return_to"]').forEach(input => {
          input.value = landing.pathname + landing.search + landing.hash;
        });
        form.requestSubmit();
      }
    }
  } catch (_) { /* Native market selection remains usable without storage. */ }
})();
